export default __webpack_public_path__ + "images/c7a239db82f5e7c23e25c46e2efff420.jpg";